import { render } from "./ViewContainer.vue?vue&type=template&id=746913b8&scoped=true&ts=true"
import script from "./ViewContainer.vue?vue&type=script&lang=ts"
export * from "./ViewContainer.vue?vue&type=script&lang=ts"

import "./ViewContainer.scss?vue&type=style&index=0&id=746913b8&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746913b8"]])

export default __exports__